module.exports = __webpack_public_path__ + "img/VL_17_01.eb50c842.png";